import { TabPanel, TabView } from "primereact/tabview";
import React from "react";
import {
  Link
} from "react-router-dom";
import { PrivateRoutes } from "../../../routes/routes";

function TabUnidadesComponent({ listaUnidades, listaLecciones, cursoPersona }) {
  return (
    <div className="field col-12 md:col-7 movilBackground containerListUnidadDesktop"  >
      <div className="border rounded-9 shadow p-md-4 mb-md-4 cardTabs card3Y4min-height card3Y4minpadding">
        <div className="row g-2 mb-2 align-items-center">
          <TabView className="tabviewProgreso progreso-desktop-block ">
            {listaUnidades.map((item, i) => {
              return (
                <TabPanel key={i} header={"Unidad " + (i + 1)}>
                  <span
                    class="subtitle fontsizeunset h4"
                    data-v-48f3e599=""
                    style={{ marginTop: "0",marginBottom: "10px" }}
                  >
                    {item.descripcion}
                  </span>
                  <p
                    className="fontsizeunset"
                    dangerouslySetInnerHTML={{ __html: item.logro }}
                  />
                  <p className="mt-2">
                    <b className="fontsizeunset">Lecciones</b>
                  </p>
                  {listaLecciones &&
                    listaLecciones
                      .filter((x) => x.idUnidad == item.idUnidad)
                      .map((itemj, j) => {
                        return (
                          <div className="contenido-lecciones"  >
                           
                              <span
                                className="lecciones"
                                style={{ color: "#010101" }}
                              >
                                {"- Lección " + (j + 1) + ": "}
                              </span>
                            
                            {cursoPersona[0].idEstado == 3 ? (
                              
                                <span
                                  className="fontsizeunset"
                                  style={{ color: "#7C7C7C" }}
                                >
                                  {itemj.descripcion}
                                </span>
                              
                            ) : (
                              
                                <Link
                                  className="fontsizeunset"
                                  to={
                                    "/" +
                                    PrivateRoutes.HOME +
                                    "/CursoInterno/" +
                                    cursoPersona[0].idPersonaCurso +
                                    "/" +
                                    item.idUnidad +
                                    "/" +
                                    itemj.idLeccion
                                  }
                                  style={{
                                    color: "blue",
                                  }}
                                >
                                  {itemj.descripcion}
                                </Link>
                              
                              
                            )}
                          </div>
                        );
                      })}
                </TabPanel>
              );
            })}
          </TabView>
          <TabView className="tabviewProgreso progreso-mobile" scrollable>
            {listaUnidades.map((item, i) => {
              return (
                <TabPanel
                  key={i}
                  header={"Unidad " + (i + 1)}
                  style={{ color: "black" }}
                >
                  <span
                    class="subtitle fontsizeunset h4"
                    data-v-48f3e599=""
                    style={{ marginTop: "0",marginBottom: "10px" }}
                  >
                    {item.descripcion}
                  </span>
                  <p
                    className="fontsizeunset"
                    dangerouslySetInnerHTML={{ __html: item.logro }}
                  />
                  <p className="mt-2">
                    <b className="fontsizeunset">Lecciones</b>
                  </p>
                  {listaLecciones &&
                    listaLecciones
                      .filter((x) => x.idUnidad == item.idUnidad)
                      .map((itemj, j) => {
                        return (
                          <div className="contenido-lecciones">
                            <span
                              className="fontsizeunset"
                              style={{ color: "#010101" }}
                            >
                              {"- Lección " + (j + 1) + ": "}
                            </span>

                            {cursoPersona[0].idEstado != 2 ? (
                              <span
                                className="fontsizeunset"
                                style={{ color: "#7C7C7C" }}
                              >
                                {itemj.descripcion}
                              </span>
                            ) : (
                              // <a href="" onClick={() => handleLinkClickCursos(item, itemj)} className="fontsizeunset">
                              //   {itemj.descripcion}
                              // </a>
                              <Link
                                //className="fontsizeunset"
                                style={{
                                  color: "blue",
                                }}
                                to={
                                  "/" +
                                  PrivateRoutes.HOME +
                                  "/CursoInterno/" +
                                  cursoPersona[0].idPersonaCurso +
                                  "/" +
                                  item.idUnidad +
                                  "/" +
                                  itemj.idLeccion
                                }
                              >
                                {itemj.descripcion}
                              </Link>
                            )}
                          </div>
                        );
                      })}
                </TabPanel>
              );
            })}
          </TabView>
        </div>
      </div>
    </div>
  );
}

export default TabUnidadesComponent;
